import { AccessRoleCodes } from "Models/AccessRoleCodes";
import { isHunter } from "Hooks/useIsCurrentUserHunter";
import { isMerchant } from "Hooks/useIsCurrentUserMerchant";
import {
  OrbitLPhase,
  type OrbitLStatusDto,
  TerminalFinancingModel,
} from "Infrastructure/Api/Api";

const ORBIT_L_TERMINAL_MANAGEMENT_ROLES = [
  AccessRoleCodes.Admin,
  AccessRoleCodes.Hunter,
  AccessRoleCodes.HunterPlus,
  AccessRoleCodes.Merchant,
] as const;

export const ORBIT_L_PHASES_BEFORE_SUBMISSION: ReadonlyArray<OrbitLPhase> = [
  OrbitLPhase.RequiresCompletion,
  OrbitLPhase.ReadyToDownloadContract,
  OrbitLPhase.ContractDownloaded,
];

export const isBeforeComgateSubmission = ({ phase }: OrbitLStatusDto) =>
  ORBIT_L_PHASES_BEFORE_SUBMISSION.includes(phase);

type Params = {
  userRole: string | null;
  isOnboarding: boolean | undefined;
  orbitLStatus: OrbitLStatusDto | undefined;
};

/**
 * Whether the caller sees the terminal counts on the Orbit L card (and, once the order is with
 * Comgate, the change request built from them). Hunters only before submission, merchants only
 * when the terminals are not hunter-financed.
 */
export const canManageOrbitLTerminals = ({
  userRole,
  isOnboarding,
  orbitLStatus,
}: Params) => {
  if (isOnboarding || !orbitLStatus) {
    return false;
  }

  return (
    ORBIT_L_TERMINAL_MANAGEMENT_ROLES.includes(
      userRole as (typeof ORBIT_L_TERMINAL_MANAGEMENT_ROLES)[number],
    ) &&
    (!isHunter(userRole) || isBeforeComgateSubmission(orbitLStatus)) &&
    (!isMerchant(userRole) ||
      orbitLStatus.financingModel !== TerminalFinancingModel.Hunter)
  );
};
